var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTargetGoalSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    viewBox: "0 0 17 17",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    transform: "translate(2.251251 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.278749 5.97-1.8825 1.8825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.24874918 3v3h3.00000002l3-3-2.00025-.99975-.99975-2.00025z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.99874918 1.48125h.00000008c-3.5224725.2161965-6.2027325 3.2469825-5.9865375 6.769455.2161965 3.5224725 3.2469825 6.2027325 6.769455 5.9865375 3.22110754-.1977 5.78924254-2.7661125 5.98658254-5.9872425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.90624918 8.25c-.21245925 1.94559-1.96191 3.3505725-3.9075 3.1381125-1.94559-.2124593-3.3505725-1.96191-3.1381125-3.9075.18046725-1.652625 1.4854875-2.9576475 3.1381125-3.1381125"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h18v18h-18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetGoalSecond);
export default __webpack_public_path__ + "static/media/target-goal-second.5f3bea8edf9a5a575460488d8337d56f.svg";
export { ForwardRef as ReactComponent };